import React from "react";
import PropTypes from 'prop-types';
import { Rnd } from "react-rnd";
import { connect } from 'react-redux';

import Overlay from './Overlay';
import classNames from "classnames";

import * as ElementActions from "../../data/elements/ElementActions";

const classes = {
    container: classNames(
        'absolute inline-block overflow-hidden',
    )
};

class Container extends React.Component
{
    static propTypes = {
        top: PropTypes.number.isRequired,
        left: PropTypes.number.isRequired,
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
        position: PropTypes.number.isRequired,

        editable: PropTypes.bool,
        active: PropTypes.bool,
        onClick: PropTypes.func,

        // if editable...
        id: PropTypes.string,
        elementChanging: PropTypes.func,
    };

    static defaultProps = {
        editable: false,
        active: false,
        onClick: () => {},
    };

    onDrag = (event, data) => {
        this.props.elementChanging(
            this.props.id,
            {
                x: data.x,
                y: data.y
            }
        );
    };

    onDragStart = (event, data) => {
        event.stopPropagation();
    };

    onDragStop = (event, data) => {
        console.log('onDragStop', data);
        this.props.elementChanging(
            this.props.id,
            {
                x: data.x,
                y: data.y
            }
        );
        this.props.elementChanged(this.props.id);
    };

    onResize = (event, direction, ref, delta, position) => {
        this.props.elementChanging(
            this.props.id,
            {
                width: ref.offsetWidth,
                height: ref.offsetHeight,
                ...position
            }
        );
    };

    onResizeStop = (event, direction, ref, delta, position) => {
        this.props.elementChanged(this.props.id);
    };

    render()
    {
        const { top, left, width, height, position } = this.props;
        const { onClick, editable, active } = this.props;

        if ( ! editable) {
            return this.renderStatic(top, left, width, height, position);
        }

        const size = {
            width: width,
            height: height
        };

        const placement = {
            x: left,
            y: top
        };

        return <Rnd
            size={size}
            position={placement}
            bounds='parent'
            onDrag={this.onDrag}
            onDragStart={this.onDragStart}
            onDragStop={this.onDragStop}
            onResize={this.onResize}
            onResizeStop={this.onResizeStop}
            disableDragging={! active}
            enableResizing={{
                top: active,
                right: active,
                bottom: active,
                left: active,
                topRight: active,
                bottomRight: active,
                bottomLeft: active,
                topLeft: active
            }}
            resizeHandleClasses={{
                bottomLeft: 'z-50 bg-indigo-500 shadow',
                bottomRight: 'z-50 bg-indigo-500 shadow',
                topLeft: 'z-50 bg-indigo-500 shadow',
                topRight: 'z-50 bg-indigo-500 shadow',
            }}
            resizeHandleStyles={{
                bottomLeft: {width: 10, height: 10, bottom: 0, left: 0},
                bottomRight: {width: 10, height: 10, bottom: 0, right: 0},
                topLeft: {width: 10, height: 10, top: 0, left: 0},
                topRight: {width: 10, height: 10, top: 0, right: 0},
            }}
            style={{zIndex: position}}
        >
            <div className={classes.container} style={{...size}}>
                {this.props.children}
            </div>
            <Overlay active={active} onClick={onClick} />
        </Rnd>;
    }

    renderStatic(top, left, width, height, position)
    {
        const styles = {
            left: left,
            top: top,
            width: width,
            height: height,
            zIndex: position
        }

        return <div className={classes.container} style={styles}>
            {this.props.children}
        </div>;
    }
}







const mapStateToProps = (state, ownProps) => ({

});

const mapDispatchToProps = {
    elementChanging: ElementActions.elementChanging,
    elementChanged: ElementActions.elementChanged,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Container);
